import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import ReactGA from "react-ga4";

// Initialize your GA4 Measurement ID (replace with yours)
ReactGA.initialize("G-C0R3K9ZGGT");

function AnalyticsTracker() {
    const location = useLocation();
  
  
    useEffect(() => {
      const pagePath = decodeURI(location.pathname + location.search);
      ReactGA.send({
        hitType: "pageview",
        page_path: pagePath,
        page_location: window.location.href,
      });
    }, [location]);
  
    return null;
  }
  
  export default AnalyticsTracker;